module.exports = __webpack_public_path__ + "img/buy_back.5070d34c.png";